export default __webpack_public_path__ + "static/media/7.64db9930.webp";